import { DictionariesService } from "./services/DictionariesService";

const apiUrl = process.env.REACT_APP_API_URL;

export const dictionariesService = new DictionariesService(apiUrl);